import { SVGAttributes } from 'react'

export default function LinesLeft(attributes: SVGAttributes<SVGSVGElement>): JSX.Element {
	return (
		<svg {...attributes} width="234" height="96" viewBox="0 0 234 96" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M-38.8505 21.0159C-2.46615 25.0508 34.6068 28.6146 71.9027 31.4814" stroke="#79C2BE" strokeWidth="12" strokeMiterlimit="10" strokeLinecap="round"/>
			<path d="M16.7955 69.7871C85.1479 76.2903 155.174 80.8447 224.313 82.2468" stroke="#8DC63F" strokeWidth="16" strokeMiterlimit="10" strokeLinecap="round"/>
			<path d="M-98.0963 46.7266C-17.21 56.2414 66.3565 64.1037 150.432 69.4141" stroke="#6BAF45" strokeWidth="16" strokeMiterlimit="10" strokeLinecap="round" style={{ mixBlendMode: 'multiply' }}/>
		</svg>
	)
}
